import { useParamsOr404 } from './use-params-or-404'

export function useWellId() {
  return useParamsOr404('id').id
}
